import AdminOperationsScreen from "../../../src/features/arrangements/screens/AdminOperationsScreen";

export default function CaseSignaturePacketsRoute() {
  return <AdminOperationsScreen screenIdOverride="signature-packet" />;
}
